import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { TFunction } from "i18next";
import { memo, useMemo } from "react";
import { TbCar } from "react-icons/tb";

import { TableHeader } from "@/components/TableHeader";
import { PlanAssignationCell } from "@/pages/Plannn/components/table/PlanAssignationColumn";
import useDriversContext from "@/providers/data/DriversContext";

import { HotelClinicTaskResolved } from "../../types";

/** Read-only driver display; resolves `driverUserId` vs driver list (`userId` / `id`). */
const ClinicArrivalTaskDriverCell = memo(function ClinicArrivalTaskDriverCell({
    row,
}: {
    row: HotelClinicTaskResolved;
}) {
    const { drivers } = useDriversContext();
    const uid = (row.driverUserId ?? "").trim();

    const driver = useMemo(() => drivers.find((d) => d.userId === uid || d.id === uid), [drivers, uid]);
    if (!uid) {
        return <span className="text-xs text-gray-400">—</span>;
    }

    if (driver?.id) {
        return <PlanAssignationCell error={undefined} value={driver.id} />;
    }

    return <span className="truncate text-xs font-medium text-slate-600">{uid}</span>;
});

export default function ClinicArrivalTaskDriverColumn({ t }: { t: TFunction }): GridColDef<HotelClinicTaskResolved> {
    return {
        field: "driverUserId",
        headerName: t("driver"),
        minWidth: 200,
        flex: 0.45,
        editable: false,
        filterable: false,
        renderHeader: (params) => <TableHeader Component={TbCar} title={params.colDef.headerName!} />,
        valueGetter: (_val, row) => row.driverUserId ?? "",
        renderCell: (params: GridRenderCellParams<HotelClinicTaskResolved>) => (
            <ClinicArrivalTaskDriverCell row={params.row} />
        ),
    };
}
